if (!customElements.get('bio-product')) {
  customElements.define(
    'bio-product',
    class BioProduct extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-thumb]')];
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.showSlide(thumb.dataset.thumb)));

        this.idInput = this.querySelector('[data-bp-id]');
        this.quantityInput = this.querySelector('[data-bp-quantity]');
        this.planInput = this.querySelector('[data-bp-plan]');
        this.renewNote = this.querySelector('[data-bp-renew]');
        this.querySelectorAll('.bp-offer__radio').forEach((radio) => {
          radio.addEventListener('change', () => this.selectOffer(radio));
        });

        this.lightbox = this.querySelector('[data-lightbox]');
        this.querySelector('[data-zoom]')?.addEventListener('click', () => this.openLightbox());
        this.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.lightbox.close());

        this.ctaPrice = this.querySelector('[data-bp-cta-price]');
        this.ctaCompare = this.querySelector('[data-bp-cta-compare]');
        if (this.querySelector('.bp-offer__radio[data-plan]:not([data-plan=""])')) {
          this.removeAppWidgets();
        } else {
          this.followAppWidget();
        }
        this.timers = [];

        this.accordions = [...this.querySelectorAll('[data-bp-accordion]')];
        this.accordions.forEach((accordion) => {
          accordion.addEventListener('toggle', () => {
            if (!accordion.open) return;
            this.accordions.forEach((other) => {
              if (other !== accordion) other.open = false;
            });
          });
        });

        this.querySelectorAll('.bp-ingredients').forEach((wrapper) => {
          const modal = wrapper.querySelector('[data-bp-modal]');
          wrapper.querySelector('[data-bp-modal-open]').addEventListener('click', () => modal.showModal());
          wrapper.querySelector('[data-bp-modal-close]').addEventListener('click', () => modal.close());
          modal.addEventListener('click', (event) => {
            if (event.target === modal) modal.close();
          });
        });
        this.querySelectorAll('[data-bp-names]').forEach((names) => this.startNames(names));
        this.querySelectorAll('[data-bp-stock]').forEach((stock) => this.startStock(stock));
      }

      disconnectedCallback() {
        this.timers?.forEach(clearInterval);
        this.widgetObserver?.disconnect();
        this.planObserver?.disconnect();
      }

      // A subscription app's widget picks the plan. Each plan says how many bottles it is
      // (a "Buy 2 Get 1 Free" plan is 3), so the quantity, button price and refill days follow it.
      followAppWidget() {
        const data = this.querySelector('[data-bp-plans]');
        const form = this.querySelector('.bp-form form');
        if (!data || !form) return;
        try {
          this.plans = JSON.parse(data.textContent);
        } catch (error) {
          return;
        }
        const sync = () => {
          const checked = form.querySelector('input[type="radio"][name="selling_plan"]:checked');
          if (checked) this.applyPlan(checked.value);
          return Boolean(checked);
        };
        form.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"][name="selling_plan"]')) sync();
        });
        form.addEventListener('click', () => setTimeout(sync, 0));
        if (sync()) return;
        this.planObserver = new MutationObserver(() => {
          if (sync()) this.planObserver.disconnect();
        });
        this.planObserver.observe(form, { childList: true, subtree: true });
      }

      applyPlan(planId) {
        const plan = this.plans[planId] || this.plans[''];
        if (!plan) return;
        this.quantityInput.value = plan.qty;
        if (this.ctaPrice) this.ctaPrice.textContent = plan.price;
        if (this.ctaCompare) {
          this.ctaCompare.textContent = plan.compare;
          this.ctaCompare.hidden = !plan.compare;
        }
        this.querySelectorAll('[data-bp-refill-days]').forEach((days) => {
          days.textContent = plan.days;
        });
      }

      // The offer cards already choose the subscription plan. A subscription app's own widget
      // injected into this form would add a second selling_plan field, so it is removed.
      removeAppWidgets() {
        const form = this.querySelector('.bp-form form');
        if (!form) return;
        const clean = () => form.querySelectorAll('.appstle_sub_widget').forEach((widget) => widget.remove());
        clean();
        this.widgetObserver = new MutationObserver(clean);
        this.widgetObserver.observe(form, { childList: true, subtree: true });

        // Other scripts can rewrite or drop selling_plan fields, so the chosen card's plan is
        // written back just before the cart request is built.
        form.addEventListener(
          'submit',
          () => {
            const radio = this.querySelector('.bp-offer__radio:checked');
            if (!radio || !radio.dataset.plan) return;
            form.querySelectorAll('[name="selling_plan"]').forEach((field) => {
              if (field !== this.planInput) field.remove();
            });
            if (!this.planInput || !form.contains(this.planInput)) {
              this.planInput = document.createElement('input');
              this.planInput.type = 'hidden';
              this.planInput.name = 'selling_plan';
              this.planInput.setAttribute('data-bp-plan', '');
              form.appendChild(this.planInput);
            }
            this.planInput.disabled = false;
            this.planInput.value = radio.dataset.plan;
            this.idInput.value = radio.dataset.variant;
            this.quantityInput.value = radio.dataset.quantity;
          },
          true
        );
      }

      startNames(wrapper) {
        const names = [...wrapper.children];
        if (names.length < 2) return;
        const fit = (name) => {
          wrapper.style.width = `${name.offsetWidth}px`;
        };
        let current = 0;
        fit(names[current]);
        this.timers.push(
          setInterval(() => {
            wrapper.classList.add('is-fading');
            setTimeout(() => {
              names[current].hidden = true;
              current = (current + 1) % names.length;
              names[current].hidden = false;
              fit(names[current]);
              wrapper.classList.remove('is-fading');
            }, 350);
          }, Number(wrapper.dataset.seconds) * 1000)
        );
      }

      stockStartTime(key) {
        if (window.Shopify?.designMode) return Date.now();
        const day = 86400000;
        try {
          const saved = Number(localStorage.getItem(key));
          if (saved && Date.now() - saved < day) return saved;
          const now = Date.now();
          localStorage.setItem(key, now);
          return now;
        } catch (error) {
          return Date.now();
        }
      }

      startStock(stock) {
        const start = Number(stock.dataset.start);
        const end = Number(stock.dataset.end);
        const duration = Number(stock.dataset.minutes) * 60000;
        const fill = stock.querySelector('[data-bp-stock-fill]');
        const label = stock.querySelector('[data-bp-stock-percent]');
        const startTime = this.stockStartTime(`bp-stock-${this.dataset.section}`);
        const update = () => {
          const progress = Math.min(1, (Date.now() - startTime) / duration);
          const eased = 1 - (1 - progress) ** 2;
          const percent = start + (end - start) * eased;
          fill.style.width = `${percent}%`;
          label.textContent = Math.round(percent);
          return progress < 1;
        };
        update();
        requestAnimationFrame(() => requestAnimationFrame(() => fill.classList.add('is-live')));
        const timer = setInterval(() => {
          if (!update()) clearInterval(timer);
        }, 1000);
        this.timers.push(timer);
      }

      showSlide(index) {
        this.slides.forEach((slide) => {
          slide.hidden = slide.dataset.slide !== index;
        });
        this.thumbs.forEach((thumb) => {
          if (thumb.dataset.thumb === index) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      selectOffer(radio) {
        this.idInput.value = radio.dataset.variant;
        this.quantityInput.value = radio.dataset.quantity;
        if (this.planInput) {
          // A disabled input is left out of the cart request, so one-time offers send no plan.
          this.planInput.value = radio.dataset.plan || '';
          this.planInput.disabled = !radio.dataset.plan;
        }
        if (this.renewNote) {
          this.renewNote.textContent = radio.dataset.note || '';
          this.renewNote.hidden = !radio.dataset.note;
        }
        if (this.ctaPrice) this.ctaPrice.textContent = radio.dataset.price;
        if (this.ctaCompare) {
          this.ctaCompare.textContent = radio.dataset.compare;
          this.ctaCompare.hidden = !radio.dataset.compare;
        }
        this.querySelectorAll('[data-bp-refill-days]').forEach((days) => {
          days.textContent = radio.dataset.days;
        });
      }

      openLightbox() {
        const image = this.querySelector('[data-slide]:not([hidden]) img');
        if (!image) return;
        const large = image.cloneNode();
        large.removeAttribute('sizes');
        large.removeAttribute('srcset');
        large.src = image.currentSrc || image.src;
        large.loading = 'eager';
        this.querySelector('[data-lightbox-content]').replaceChildren(large);
        this.lightbox.showModal();
      }
    }
  );
}
